import { render } from "./design_3_block.vue?vue&type=template&id=1ab8e6fe&scoped=true"
const script = {}

import "./design_3_block.vue?vue&type=style&index=0&id=1ab8e6fe&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab8e6fe"]])

export default __exports__